import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ListItemText,
} from '@material-ui/core'
import { isEqual } from 'lodash'
import React from 'react'
import { useAppSelector } from 'store/configureStore'
import { ImgLoader } from '../../../components/Common/ImgLoader/ImgLoader'
import { CuttingPlanDto } from '../../../services/APIs/InternalAPI/internal-api.contracts'
import { useOrganizationAndProjectContext } from '../../../utils/useOrganizationContext'
import { bomItemMaterialSummarySelector } from '../store/selectors/bomItemMaterialSummarySelector'
import './ActiveCuttingPlanDialog.scss'
import { CuttingPlanDetails } from './CuttingPlanDetails'

export type CuttingPlanDialogProps = {
  cuttingPlan: CuttingPlanDto
  materialHeaderId: string
  open?: boolean
  onClose?: () => void
}

export const CuttingPlanDialog = (props: CuttingPlanDialogProps) => {
  const { partyId: organizationId, projectId } =
    useOrganizationAndProjectContext()

  const materialSummary = useAppSelector(
    bomItemMaterialSummarySelector(props.materialHeaderId),
    isEqual
  )

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>cutting plans</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <ListItemText
            primary={materialSummary.description}
            primaryTypographyProps={{
              variant: 'subtitle1',
              color: 'primary',
            }}
            secondary={`quantity: ${props.cuttingPlan.quantity}`}
          />
        </DialogContentText>
        <div className="cutting-plan-image">
          <ImgLoader
            src={`api/parties/${organizationId}/projects/${projectId}/nesting/2d/images/${props.cuttingPlan.fileNameOfNestingImage}`}
            alt="cutting plan"
          />
        </div>
      </DialogContent>
      {props.cuttingPlan.details ? (
        <CuttingPlanDetails details={props.cuttingPlan.details} />
      ) : null}

      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => props.onClose()}
          color="secondary"
        >
          close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
